import { useMutation, useQuery } from "@tanstack/react-query";
import { backendService } from "../../services/backend.service";
import type { PbjCalculatorParams } from "../../utils/models";

export const usePbjCalculator = () =>
	useMutation({
		mutationFn: async (params: PbjCalculatorParams) => {
			const response = await backendService.calculatePbjMetrics(params);
			return response.data;
		},
	});

export const useSearchPbjFacilities = (query: string, enabled: boolean = true) =>
	useQuery({
		queryKey: ["pbj-facilities", query],
		queryFn: async () => {
			const response = await backendService.searchPBJFacilities(query);
			return response.data;
		},
		enabled: enabled && query.length >= 2,
		staleTime: 5 * 60 * 1000,
	});
